<template>
    <div>
        <section class="jumbotron text-center">
            <h1>Guest details</h1>
            <p class="lead text-muted">
                {{firstName}} {{lastName}}
            </p>
            <p class="lead text-muted">
                {{email}}
            </p>
        </section>
        <section>
            <b-card-group columns>
                <b-card v-if="guest">
                    <h4>
                        Guest
                        <b-badge style="float: right">
                            <i class="fa fa-user"></i>
                        </b-badge>
                    </h4>
                    <b-card-body>
                        {{firstName}} {{lastName}}
                        <br />
                        {{email}}
                    </b-card-body>
                    <qrcode-vue :value="guest.code"></qrcode-vue>
                    <pre>{{guest.code}}</pre>
                </b-card>
                <router-view name="guestprofile"/>
            </b-card-group>
            <br />
            <router-view name="guesthistory" :event_id="event_id" />
            <br />
            <b-card>
		        <h4>
		            Badges
		            <b-badge style="float: right">
		                <i class="fa fa-id-badge"></i>
		            </b-badge>
		        </h4>
        		<router-view name="guestbadges"/>
        	</b-card>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import QrcodeVue from 'qrcode.vue';

export default {
    name: "guestDetails",
    props: ["event_id", "guest_id"],
    components: {
        QrcodeVue
    },
    data: () => {
        return {
            resources: {
                events: "/events",
                guests: "/guests",
                schema: "/schema"
            },
            guest: undefined
        };
    },
    methods: {
        fetchData(resource) {
            return axios
                .get(this.$store.getters.apiBase + this._data.resources.events + "/" + this._props["event_id"] +
            this._data.resources.guests + "/" + this._props["guest_id"], {
                    headers: {
                        "Content-Type": "application/json",
                        
                        Authorization: this.$store.getters.accessToken,
                        account_id: this.$store.getters.accountId
                    }
                })
                .then(response => {
                    this.$data.guest = response.data;
                    return response;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        email() {
            return this.guest ? this.guest.email : undefined;
        },
        firstName() {
            return this.guest ? this.guest.first_name : undefined;
        },
        lastName() {
            return this.guest ? this.guest.last_name : undefined;
        }
    },
    async created() {
       this.fetchData();
    }
};
</script>